// extracted by mini-css-extract-plugin
export var box = "_5n-0";
export var check = "_5n-1";
export var checkboxButton = "_5n-6";
export var checkboxGroup = "_5n-5";
export var disabled = "_5n-7";
export var ghost = "_5n-9";
export var input = "_5n-2";
export var label = "_5n-4";
export var normal = "_5n-8";
export var uncheck = "_5n-3";